export const GITHUB_APP_CLIENT_ID =
  process.env.REACT_APP_GITHUB_APP_CLIENT_ID || ''
export const GITHUB_APP_REDIRECT_URL =
  process.env.REACT_APP_GITHUB_APP_REDIRECT_URL || ''
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || ''
